import * as XLSX from 'xlsx'

function parseSheetWithMergedCells(sheet) {
  if (!sheet['!ref']) {
    return []
  }

  const range = XLSX.utils.decode_range(sheet['!ref'])
  const rows = []

  for (let r = range.s.r; r <= range.e.r; r++) {
    rows[r] = []
    for (let c = range.s.c; c <= range.e.c; c++) {
      rows[r][c] = null
    }
  }

  if (sheet['!merges']) {
    sheet['!merges'].forEach((merge) => {
      const startCell = XLSX.utils.encode_cell(merge.s)
      const value = sheet[startCell]?.v
      if (value !== undefined && value !== null) {
        for (let r = merge.s.r; r <= merge.e.r; r++) {
          for (let c = merge.s.c; c <= merge.e.c; c++) {
            rows[r][c] = value
          }
        }
      }
    })
  }

  Object.keys(sheet).forEach((key) => {
    if (key.startsWith('!')) return
    const cell = XLSX.utils.decode_cell(key)
    const cellData = sheet[key]
    rows[cell.r][cell.c] = cellData.f ? { formula: cellData.f, value: cellData.v } : cellData.v
  })

  return rows.filter((row) => row.some((cell) => cell !== null && cell !== undefined && cell !== ''))
}

// ヘッダーなどをまとめてJSON形式にする関数。今のところ不使用
function convertMatrixToStructuredJSON(matrix) {
  if (!matrix || matrix.length === 0 || !matrix[0]) {
    return []
  }

  let headers
  let startRowIndex
  if (matrix.length === 1) {
    headers = matrix[0].map((h, i) => h || `col_${i + 1}`)
    startRowIndex = 0
  } else {
    headers = matrix[0].map((header, index) =>
      header === null || header === undefined || header === '' ? `col_${index + 1}` : header
    )
    startRowIndex = 1
  }

  const data = []

  for (let i = startRowIndex; i < matrix.length; i++) {
    const row = matrix[i]
    const rowObject = {}
    headers.forEach((header, index) => {
      rowObject[header] = row[index] || null
    })
    data.push(rowObject)
  }

  return data
}

export async function handleExcelFiles(files) {
  if (!files || !Array.isArray(files) || !files.length) return null
  const allData = {}
  const errors = []

  //読み込みを中断させないためにエラーが出てもresolveする
  const processFile = (file) =>
    new Promise((resolve) => {
      const reader = new FileReader()
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result)
          const workbook = XLSX.read(data, { type: 'array' })
          const fileName = file.name
          allData[fileName] = {}

          workbook.SheetNames.forEach((sheetName) => {
            const sheet = workbook.Sheets[sheetName]
            const matrix = parseSheetWithMergedCells(sheet)
            allData[fileName][sheetName] = matrix
          })
        } catch (error) {
          console.error(`エラー発生: ${file.name}`, error)
          errors.push(file.name ?? '不明なファイル')
        }
        resolve()
      }

      reader.onerror = () => {
        console.error(`読み込みエラー: ${file.name}`)
        errors.push(file.name ?? '不明なファイル')
        resolve()
      }

      try {
        reader.readAsArrayBuffer(file)
      } catch (error) {
        console.error(`ファイル読み込みエラー: ${file.name}`, error)
        errors.push(file.name ?? '不明なファイル')
        resolve()
      }
    })

  await Promise.all(Array.from(files).map((file) => processFile(file)))

  return { data: allData, message: 'success', errors }
}
